
import {Todo, User} from '@/modules';
import axios, { AxiosResponse } from 'axios';
import { defineComponent } from 'vue';

export default defineComponent({
  data() {
    return {
      users: [] as User[],
      selectedUser: null as User | null,
      editUser: null as User | null,
      todos: [] as Todo[],
      showTodoModal: false,
      showEditModal: false,
      isLoading: false,
    };
  },
  computed: {
    emailValidationRules(): ((v: string) => string | true)[] {
      return [
        (v: string) => !!v || 'Email обязателен к заполнению',
        (v: string) => /.+@.+\..+/.test(v) || 'Введите корректный email',
      ];
    },
    phoneValidationRules(): ((v: string) => string | true)[] {
      return [
        (v: string) => !!v || 'Номер телефона обязателен к заполнению',
        (v: string) => /^\d{10}$/.test(v) || 'Введите 10 цифр номера телефона',
      ];
    },
  },
  async mounted() {
    this.loadFromLocalStorage();
    if (this.users.length === 0 || this.todos.length === 0) {
      await Promise.all([this.getUsers(), this.getTodos()]);
    }
  },
  methods: {
    async getUsers(): Promise<void> {
      this.isLoading = true;
      try {
        const response: AxiosResponse<User[]> = await axios.get('https://jsonplaceholder.typicode.com/users');
        this.users = response.data;
        this.saveToLocalStorage();
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    async getTodos(): Promise<void> {
      this.isLoading = true;
      try {
        const response: AxiosResponse<Todo[]> = await axios.get('https://jsonplaceholder.typicode.com/todos');
        this.todos = response.data;
        this.saveToLocalStorage();
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async showUserDetails(user: User): Promise<void> {
      this.selectedUser = user;
      this.isLoading = true;
      try {
        if (localStorage.getItem('todos') && JSON.parse(localStorage.getItem('todos')!).length > 0) {
          this.todos = JSON.parse(localStorage.getItem('todos')!) as Todo[];
          this.showTodoModal = true;
        } else {
          const response: AxiosResponse<Todo[]> = await axios.get(`https://jsonplaceholder.typicode.com/users/${user.id}/todos`);
          this.todos = response.data;
          this.showTodoModal = true;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    openEditModal(user: User): void {
      this.selectedUser = user;
      this.editUser = { ...user };
      this.showEditModal = true;
    },
    saveUserData(): void {
      if (this.selectedUser && this.editUser) {
        Object.assign(this.selectedUser, this.editUser);
        this.saveToLocalStorage();
        this.closeEditModal();
      }
    },
    cancelEdit(): void {
      this.editUser = null;
      this.closeEditModal();
    },
    closeEditModal(): void {
      this.showEditModal = false;
    },
    saveTodoList(): void {
      this.saveToLocalStorage();
      this.closeTodoModal();
    },
    closeTodoModal(): void {
      this.showTodoModal = false;
    },
    truncateText(text: string, length: number): string | undefined {
      if (text && text.length) {
        if (text.length <= length) {
          return this.capitalizeFirstLetter(text);
        }
        const truncatedText = text.slice(0, length);
        return this.capitalizeFirstLetter(truncatedText);
      }
    },
    capitalizeFirstLetter(text: string): string {
      return text.charAt(0).toUpperCase() + text.slice(1);
    },
    saveToLocalStorage(): void {
      localStorage.setItem('users', JSON.stringify(this.users));
      localStorage.setItem('todos', JSON.stringify(this.todos));
    },
    loadFromLocalStorage(): void {
      const users = localStorage.getItem('users');
      const todos = localStorage.getItem('todos');
      if (users) {
        this.users = JSON.parse(users) as User[];
      }
      if (todos) {
        this.todos = JSON.parse(todos) as Todo[];
      }
    },
  }
});
